export default __webpack_public_path__ + "static/media/redCar.33e1888e.jpg";